import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { TableForm } from 'components/Commons';
import PropTypes from 'prop-types';
import { safeHistoryPush } from 'helpers/pathValidator';

import numeral from 'numeral';

const propTypes = {};
const defaultProps = {};

class SettlementResult extends Component {
  render() {
    const { trading } = this.props;
    const tabledata = {
      header: {
        main: [
          { data: '정산시작일', textAlign: 'center' },
          { data: '정산종료일', textAlign: 'center' },
          { data: '정산범위', textAlign: 'center' },
          { data: '승인상태', textAlign: 'center' },
          { data: '식대총합', textAlign: 'center' },
          { data: '서비스이용료', textAlign: 'center' },
          { data: '품목비', textAlign: 'center' },
          { data: '정산금액', textAlign: 'center' },
          { data: '명세서 확인', textAlign: 'center' },
          { data: '세금계산서 발행', textAlign: 'center' },
          { data: '계좌 입금', textAlign: 'center' },
          { data: '정산확정', textAlign: 'center' }
        ]
      },
      body: {
        message: '정산 내역이 존재하지 않습니다.',
        main: null
      }
    };

    if (trading && trading.data && trading.data.companyTradingList) {
      tabledata.body.main = trading.data.companyTradingList.map((item) => {
        return {
          clickFunc: `/main/settlementDetail/${item.companyId}/${item.taxUnitSeq}`,
          clickComponent: () => {
            safeHistoryPush(this.context.router.history, `/main/settlementDetail/${item.companyId}/${item.taxUnitSeq}`);
          },
          clickData: item,
          row: [
            {
              data: moment(item.settleStartYmd).format('YYYY-MM-DD'),
              textAlign: 'center'
            },
            {
              data: moment(item.settleEndYmd).format('YYYY-MM-DD'),
              textAlign: 'center'
            },
            {
              data: item.taxGroupName,
              textAlign: 'center'
            },
            {
              data: item.approvalTypeName,
              textAlign: 'center'
            },
            {
              data: numeral(item.mealAmt).format('0,0'),
              textAlign: 'right'
            },
            {
              data: numeral(item.serviceAmt).format('0,0'),
              textAlign: 'right'
            },
            {
              data: numeral(item.itemSumAmt).format('0,0'),
              textAlign: 'right'
            },
            {
              data: numeral(item.settleAmt).format('0,0'),
              textAlign: 'right'
            },
            {
              data: (
                <div style={{ color: item.companySettlementStatus.statementStatus === '승인거절' ? 'red' : null }}>
                  {item.companySettlementStatus.statementStatus || '-'}
                </div>
              ),
              textAlign: 'center'
            },
            {
              data: (
                <div style={{ color: item.companySettlementStatus.taxInvoiceStatus === '발급실패' ? 'red' : null }}>
                  {item.companySettlementStatus.taxInvoiceStatus || '-'}
                </div>
              ),
              textAlign: 'center'
            },
            {
              data: item.companySettlementStatus.bankDepositStatus || '-',
              textAlign: 'center'
            },
            {
              data: item.companySettlementStatus.settlementStatus || '-',
              textAlign: 'center'
            }
          ]
        };
      });
    }

    return (
      <div>
        <div style={{ lineHeight: 3, fontSize: 'small', color: '#7d7d7d', textAlign: 'end' }}>
          ※ [입금자명 + 금액]이 일치해야 입금완료로 처리가 됩니다. 문의사항은 식권대장으로 연락 바랍니다.
        </div>
        <div className="table-box">
          <TableForm selectable="true" tabledata={tabledata} />
        </div>
      </div>
    );
  }
}

SettlementResult.propTypes = propTypes;
SettlementResult.defaultProps = defaultProps;

SettlementResult.contextTypes = {
  router: PropTypes.object.isRequired
};

SettlementResult = connect((state) => ({
  trading: state.settlement.tradingList
}))(SettlementResult);

export default SettlementResult;
